// This must equal the bonusType.js file in
// functions/src/methods/points/shared/bonus
export const BonusType = {
    NONE: 'none',
    TIMES_THREE: 'times_three',
    WILD_CARD: 'wild_card',
    PLUS_30_SECONDS: 'plus_30_seconds'
}
